import { Container } from "react-bootstrap";
import TitleForm from "../../components/title/TitleForm";

const Home = () => {
  return (
    <div>
      <Container fluid="md">
        <TitleForm />
      </Container>
    </div>
  );
};

export default Home;
